import { MdLockOutline } from 'react-icons/md';

import { cn } from '../../../../../../../utilities/cn';
import { PresetEditableCell } from './PresetEditableCell';

interface PresetTableCellProps {
  value: string;
  rowIndex: number;
  colIndex: number;
  isInjected: boolean;
  onUpdate: (rowIndex: number, colIndex: number, value: string) => void;
  multiline?: boolean;
  className?: string;
}

export function PresetTableCell({
  value,
  rowIndex,
  colIndex,
  isInjected,
  onUpdate,
  multiline = false,
  className,
}: PresetTableCellProps) {
  if (isInjected) {
    return (
      <span
        title="Auto-filled from fund figures — not editable"
        className={cn(
          'flex h-full w-full cursor-default items-center gap-1 bg-gray-100 px-2 py-1.5 text-gray-600',
          className,
        )}
      >
        <MdLockOutline
          className="h-3 w-3 shrink-0 text-gray-400"
          aria-hidden
        />
        <span className="min-w-0 flex-1 break-words whitespace-normal">
          {value}
        </span>
      </span>
    );
  }

  return (
    <PresetEditableCell
      value={value}
      multiline={multiline}
      className={className}
      onChange={(nextValue) => onUpdate(rowIndex, colIndex, nextValue)}
    />
  );
}
